import { Theme, Tooltip, makeStyles } from "@material-ui/core";
import React, { useState } from "react";

import { ViewEmployeeDialog } from "./ViewEmployeeDialog";

interface Props {
    isUserDeleted: boolean;
    userId: number | null;
}

export const ViewEmployeeLink = ({ isUserDeleted, userId }: Props) => {
    const classes = useStyles();
    const [employeeIdForView, setEmployeeIdForView] = useState<number | null>(null);

    return (
        <>
            <Tooltip
                title={isUserDeleted ? "Employee is deleted" : "Click to open Employee Info"}
                enterDelay={500}
                placement="top"
            >
                <p
                    className={isUserDeleted ? classes.deletedEmployeeId : classes.employeeViewLink}
                    onClick={isUserDeleted ? undefined : () => setEmployeeIdForView(userId)}
                >
                    {userId}
                </p>
            </Tooltip>
            <ViewEmployeeDialog
                open={Boolean(employeeIdForView)}
                employeeId={employeeIdForView}
                onClose={() => setEmployeeIdForView(null)}
            />
        </>
    );
};

const useStyles = makeStyles((theme: Theme) => ({
    employeeViewLink: {
        cursor: "pointer",
        fontWeight: "bold",
        color: theme.palette.primary.main,
    },
    deletedEmployeeId: {
        cursor: "not-allowed",
        fontWeight: "bold",
        color: theme.palette.grey[600],
    },
}));
